module.exports = {
  lang: {
    t1: `Home`,
    t2: `Cartão de visita`,
    t3: `Seguir`,
    t4: `Contatos`,
    t5: `Mensagens`,
    t6: `Entrar`,
    t7: `Cadastrar`,
    t8: `Nova plataforma global de conectividade comercial, novo terreno para marketing digital corporativo`,
    t9: `WeMeet - Entrar com Número de Celular`,
    t10: `Número de Celular`,
    t11: `Código de verificação`,
    t12: `Por favor, digite seu número de celular`,
    t13: `Por favor, digite o código de verificação`,
    t14: `Obter`,
    t15: `Entrar`,
    t16: `Por favor, digite o número de celular com o formato correto`,
    t17: `Código de verificação enviado`,
    t18: `Código de verificação inserido incorretamente. Por favor, verifique e insira novamente.`,
    t19: `Login bem-sucedido`,
    t20: `Seu código de verificação é (0). Por favor, utilize-o dentro de {1} minuto(s).`,
    t21: `Cancelar`,
    t22: `Confirmar`,
    t23: `Dicas úteis`,
    t24: `O seu registo na conta do WeMeet ainda não está concluído. Aja agora para completar o processo de inscrição e desfrutar de interações diversas e possibilidades ilimitadas.`,
    t25: `Ir para Inscrever-se`,
    t26: `Login WeMeet por e-mail`,
    t27: `Nome da conta`,
    t28: `Insira seu endereço de e-mail`,
    t29: `Senha`,
    t30: `Insira sua senha`,
    t31: `Esqueceu sua senha?`,
    t32: `Entrar`,
    t33: `Outros métodos de login`,
    t34: `Já registrou-se no Mini App WeMeet? Utilize agora.`,
    t35: `Faça login com o número de telefone`,
    t36: `Por favor, insira seu e-mail primeiro.`,
    t37: `Por favor, insira sua senha primeiro.`,
    t38: `O formato do e-mail é inválido`,
    t39: `Se você já tem uma conta no WeMeet, pode fazer login diretamente`,
    t40: `Entrar`,
    t41: `Imagem do perfil`,
    t42: `Por favor, envie uma imagem de perfil real`,
    t43: `Nome completo`,
    t44: `Nome`,
    t45: `Sobrenome`,
    t46: `Nome da organização`,
    t47: `Por favor, insira o nome da sua organização`,
    t48: `Cargo`,
    t49: `Por favor, insira o título do seu cargo naquela organização`,
    t50: `E-mail`,
    t51: `Insira seu endereço de e-mail`,
    t52: `Número de Celular`,
    t53: `Por favor, digite seu número de celular`,
    t54: `Região`,
    t55: `Por favor, selecione uma região`,
    t56: `Zona`,
    t57: `Por favor, selecione estado, cidade e bairro`,
    t58: `Endereço`,
    t59: `Por favor, insira seu endereço`,
    t60: `Li leu e aceito os`,
    t61: `Termos de Serviço`,
    t62: `Política de Privacidade`,
    t63: `Continuar`,
    t64: `Por favor, marque primeiro o acordo do usuário`,
    t65: `Por favor, insira o seu nome`,
    t66: `Por favor, preencha seu sobrenome`,
    t67: `Por favor, preencha o seu e-mail primeiro`,
    t68: `Por favor, preencha o nome da sua organização primeiro`,
    t69: `O formato do e-mail é inválido`,
    t70: `Cancelar`,
    t71: `Concluir`,
    t72: `Verificar número de celular`,
    t73: `Número de Celular`,
    t74: `Código de verificação`,
    t75: `Por favor, digite o código de verificação`,
    t76: `Obter`,
    t77: `Pular verificação`,
    t78: `Enviar`,
    t79: `Verificado`,
    t80: `Código de verificação inserido incorretamente. Por favor, verifique e insira novamente.`,
    t81: `Pulado`,
    t82: `Dicas úteis`,
    t83: `O número de telefone que você digitou já está registrado com uma conta WeMeet. Não é necessário se registrar novamente, faça login agora.`,
    t84: `Ir para página de login`,
    t85: `Dicas úteis`,
    t86: `O endereço de e-mail que você digitou já está registrado com uma conta WeMeet. Não é necessário se registrar novamente, faça login agora.`,
    t87: `Ir para página de login`,
    t88: `Foi enviado um link de verificação.`,
    t89: `Verifique seu e-mail e clique no link para concluir o registro.`,
    t90: `Entendi`,
    t91: `Bem-vindo ao WeMeet`,
    t92: `Bem-vindo ao WeMeet! Por favor, clique no botão para completar o seu registro. Lembrete amigável: Este link é válido por 24 horas, por favor, agir com rapidez.`,
    t93: `Registro concluído`,
    t94: `Seu e-mail foi ativado. Por favor, insira sua senha.`,
    t95: `Insira a senha`,
    t96: `Insira sua senha`,
    t97: `Confirme a senha`,
    t98: `Por favor, insira sua senha novamente`,
    t99: `Deve conter uma combinação de letras maiúsculas e minúsculas, números e caracteres especiais, com um comprimento entre 8 e 20 caracteres`,
    t100: `Insira sua senha`,
    t101: `Por favor, insira sua senha novamente`,
    t102: `As senhas não conferem`,
    t103: `Parabéns por completar o seu registo`,
    t104: `Já está logado no WeMeet. Agora pode continuar as suas ações anteriores.`,
    t105: `Continua a experimentar`,
    t106: `Dicas úteis`,
    t107: `O link expirou. Por favor, clique no botão para recuperá-lo novamente.`,
    t108: `Reenviar`,
    t109: `Termos de serviço`,
    t110: `Política de privacidade`,
    t111: `Recuperar senha`,
    t112: `Por favor, informe a conta para a qual deseja recuperar a senha`,
    t113: `Nome da conta`,
    t114: `Insira seu endereço de e-mail`,
    t115: `Enviar`,
    t116: `Por favor, insira seu e-mail primeiro.`,
    t117: `O formato do e-mail é inválido`,
    t118: `E-mail enviado`,
    t119: `Por favor, verifique seu e-mail, clique no link e redefina sua senha.`,
    t120: `Entendi`,
    t121: `Redefinir senha - WeMeet`,
    t122: `Sua solicitação de redefinição de senha foi confirmada e o sistema gerou um link temporário para redefinir a senha. Lembrete amigável: Este link é válido por 24 horas, por favor, agir com rapidez.`,
    t123: `Redefinir senha`,
    t124: `Redefinição de senha bem-sucedida`,
    t125: `Você já está logado no WeMeet. Bem-vindo de volta.`,
    t126: `Ir para a página inicial`,
    t127: `Contatos`,
    t128: `Nova solicitação de contato`,
    t129: `Aceitar`,
    t130: `Ignorar`,
    t131: `Aprovado`,
    t132: `Ignorado`,
    t133: `Seguindo`,
    t134: `Seguindo`,
    t135: `Mensagens`,
    t136: `Solicitação pendente`,
    t137: `Por favor, informe seu nome ou número de telefone`,
    t138: `Não foram encontrados conteúdos correspondentes`,
    t139: `Não há mais disponíveis`,
    t140: `Solicitação de contato`,
    t141: `Aceitar`,
    t142: `Ignorar`,
    t143: `Aprovado`,
    t144: `Ignorado`,
    t145: `Espaço WeMeet AI`,
    t146: `Seguindo`,
    t147: `Parou de seguir`,
    t148: `vCard`,
    t149: `Conectar`,
    t150: `Enviar mensagem`,
    t151: `Aguardando aprovação`,
    t152: `Remover contato`,
    t153: `Apresentação pessoal`,
    t154: `Perfil pessoal`,
    t155: `Dicas úteis`,
    t156: `Sua solicitação de contato foi enviada. Após a aprovação, você começará a segui-lo automaticamente. Você também pode optar por seguir ele(a) agora para obter mais informações sobre ele(a).`,
    t157: `Não seguir por enquanto`,
    t158: `Seguir`,
    t159: `Seguindo`,
    t160: `Remover relação de contato`,
    t161: `Após remover a relação de contato, o outro usuário não poderá mais visualizar suas informações pessoais, mas não cancelará a inscrição em você simultaneamente.`,
    t162: `Pense de novo`,
    t163: `Remover contato`,
    t164: `Operação bem-sucedida`,
    t165: `Assistente AI WeMeet`,
    t166: `Por favor, insira sua pergunta`,
    t167: `Enviar`,
    t168: `Por favor, note que o conteúdo da interação com o AI pode ser impreciso e não representar a opinião da plataforma.`,
    t169: `Cartão de visita WeMeet`,
    t170: `Baixar`,
    t171: `Editar cartão de visita`,
    t172: `Baixar código QR`,
    t173: `A imagem foi gerada. Por favor, salve-a. Escaneie o código QR para salvar o contato.`,
    t174: `Imagem do perfil`,
    t175: `Por favor, envie uma imagem de perfil real`,
    t176: `Nome completo`,
    t177: `Nome`,
    t178: `Sobrenome`,
    t179: `Por favor, insira seu nome`,
    t180: `Nome da organização`,
    t181: `Por favor, insira o nome da sua organização`,
    t182: `Cargo`,
    t183: `Por favor, insira o título do seu cargo naquela organização`,
    t184: `E-mail`,
    t185: `Insira seu endereço de e-mail`,
    t186: `Número de Celular`,
    t187: `Por favor, digite seu número de celular`,
    t188: `Região`,
    t189: `Por favor, selecione uma região`,
    t190: `Zona`,
    t191: `Por favor, selecione estado, cidade e bairro`,
    t192: `Endereço`,
    t193: `Por favor, insira seu endereço`,
    t194: `Por favor, insira o seu nome`,
    t195: `Por favor, preencha seu sobrenome`,
    t196: `Por favor, preencha o seu e-mail primeiro`,
    t197: `Por favor, preencha o nome da sua organização primeiro`,
    t198: `O formato do e-mail é inválido`,
    t199: `Sala de bate-papo`,
    t200: `Galeria de fotos`,
    t201: `Tirar uma foto`,
    t202: `Por favor, insira sua mensagem`,
    t203: `Enviar`,
    t204: `Lido`,
    t205: `Não lido`,
    t206: `Tempo limite de revogação expirado`,
    t207: `Cancelar`,
    t208: `Fotografia`,
    t209: `Álbum`,
    t210: `Fotografar`,
    t211: `Selecionar de Álbum`,
    t212: `Cancelar`,
    t213: `Fotografia`,
    t214: `Retrato`,
    t215: `Pré-visualização`,
    t216: `Concluir`,
    t217: `Espaço WeMeet AI`,
    t218: `Entre em contato`,
    t219: `Entre em contato comigo`,
    t220: `Nome completo`,
    t221: `Organização`,
    t222: `Cargo`,
    t223: `Telefone`,
    t224: `E-mail`,
    t225: `Região`,
    t226: `Zona`,
    t227: `Endereço`,
    t228: `Por favor, insira seu nome`,
    t229: `Por favor, preencha o nome da sua organização`,
    t230: `Por favor, preencha sua posição`,
    t231: `Por favor, insira o seu número de telefone`,
    t232: `Por favor, preencha seu endereço de e-mail`,
    t233: `Por favor, selecione uma região`,
    t234: `Por favor, selecione estado, cidade e bairro`,
    t235: `Por favor, insira um endereço`,
    t236: `Intenção`,
    t237: `Comprar produtos`,
    t238: `Produtos de representação`,
    t239: `Cooperação de mercado`,
    t240: `Outro`,
    t241: `Por favor, insira seu nome`,
    t242: `Por favor, preencha o nome da sua organização`,
    t243: `Por favor, preencha seu endereço de e-mail`,
    t244: `O formato do e-mail é inválido`,
    t245: `Mensagem enviada`,
    t246: `Deixe uma mensagem`,
    t247: `Por favor, digite o conteúdo da sua consulta`,
    t248: `Confirmar`,
    t249: `Por favor, efetue o login ou cadastre-se primeiro`,
    t250: `Seguidores`,
    t251: `Entre em contato conosco`,
    t252: `Produtos`,
    t253: `Equipe`,
    t254: `Visão geral`,
    t255: `Álbum`,
    t256: `Qualificação`,
    t257: `Capital social`,
    t258: `Data de fundação`,
    t259: `Endereço registrado`,
    t260: `Curso superior`,
    t261: `Curso médio`,
    t262: `Curso inferior`,
    t263: `อุตสาหกรรมที่เกี่ยวข้อง`,
    t264: `Processo`,
    t265: `Salvar`,
    t266: `Verificado`,
    t267: `Chinês`,
    t268: `Inglês`,
    t269: `Francês`,
    t270: `Russo`,
    t271: `Espanhol`,
    t272: `Japonês`,
    t273: `Coreano`,
    t274: `Indonésio`,
    t275: `Vietnamita`,
    t276: `Alemão`,
    t277: `Turco`,
    t278: `Italiano`,
    t279: `Português`,
    t280: `Tailandês`,
    t281: `Malaio`,
    t282: `Árabe`,
    t283: `Nome de usuário ou senha incorretos`,
    t284: `Por favor, leia e aceite os Termos de Uso do WeMeet antes de continuar`,
    t285: `Não há conteúdo relevante disponível`,
    t286: `Tipo`,
    t287: `Atributo`,
    t288: `Detalhes`,
    t289: `Outro`,
    t290: `No total 2 produtos`,
    t291: `{1} convida você a visitar o WeMeet AI Space de {2}`,
    t292: `Clique aqui para um exemplo ou insira uma pergunta:`,
    t293: `Atualizar`,
    t294: `Você também pode clicar no cartão de visita abaixo para adicionar contatos e obter mais informações:`,
    t295: `Aprender`,
    t296: `Reuniões digitais WeMeet`,
    t297: `Exposições digitais WeMeet`,
    t298: `Biglietto da visita e Spazio WeMeet AI`,
    t299: `Como se tornar membro de uma organização WeMeet`,
    t300: `WeMeet Serviço de Conferência Digital oferece-lhe uma solução abrangente para reuniões online, incluindo a criação e publicação de reuniões, gestão de inscrições de participantes, check-in eletrônico, programação de reuniões, partilha de material de reuniões, discussões interativas em tempo real e interações com convidados.`,
    t301: `WeMeet Exposição Digital, ajudando a construir rapidamente um microsite oficial de exposição. Mostrar informações dos expositores, descrições dos produtos em exposição, transmissões ao vivo da exposição, registo na exposição, horários de eventos, e mais, permitindo às empresas participantes e ao público compreender facilmente os detalhes da exposição. Para utilizar a função de WeMeet Exposição Digital, por favor complete primeiro o processo de entrada institucional. Clique em "Meu", role para baixo até "Centro de Serviço" - "Entrada Institucional" e siga as instruções para completar o processo de entrada.`,
    t302: `Os utilizadores pessoais da WeMeet só precisam de autorizar o seu ID WeChat, número de telefone e completar o registo na plataforma para obter um cartão de visita digital pessoal e manter o seu Salão AI pessoal (incluindo currículo pessoal, atualizações, fotos, documentos, etc.).`,
    t303: `Clique na opção "Meu" na barra de menu inferior do mini-programa para atualizar a página do cartão de visita pessoal e melhorar a página inicial pessoal.`,
    t304: `Combinação de letras maiúsculas e minúsculas, números e sinais de pontuação, com um comprimento entre 8-20 caracteres.`,
    t305: `Insira o nome do produto`,
    t306: `Não há mais`,
    t307: `Clique no canto superior direito`,
    t308: `Selecione sua forma preferida de compartilhar`,
    t309: `Eu entendi`,
    t310: `Por favor, complete o registro e login primeiro`,
    t311: `Saiba mais`,
    t312: `Produtos relacionados`,
    t313: `Obrigado pela visita`,
    t314: `Sair`,
    t315: `Organização seguida`,
    t316: `Anterior`,
    t317: `Próximo`,
    t318: `Nenhum`,
    t319: `{1} convida você a visitar {2}`,
    t320: `AI Lounge não manteve o idioma atual`,
    t321: `AI Lounge mudou para o idioma atual`,
    t322: `O link foi ativado`,
    t323: `A rede está ocupada, por favor tente novamente mais tarde`,
    t324: `Os detalhes do produto foram alterados para o idioma atual`,
    t325: `Os detalhes do produto não estão atualmente mantidos neste idioma`,
    t326: `Olá, eu sou o assistente de IA inteligente WeMeet, pronto para fornecer um serviço atencioso a qualquer momento! Como posso ajudar?`,
    t327: `Insira o nome`,
    t328: `Encontrei as informações de contato relevantes, por favor, verifique o cartão de contato abaixo.`,
    t329: `Anexo`,
    t330: `Não encontrei as informações de contato relevantes.`,
    t331: `Encaminhei sua consulta ao colega responsável abaixo; você também pode clicar no cartão de visitas para entrar em contato imediatamente.`,
    t332: `Exposição`,
    t333: `Por favor`,
    t334: `Usuário`,
    t335: `Não há mais`,
    t336: `Atualização bem-sucedida`,
    t337: `Carregando`,
    t338: `Libertar para Atualizar`,
  },
};

// 葡萄牙
